var map = {
	"./3column.svg": "5bb5",
	"./Currency.svg": "9561",
	"./Money management.svg": "c128",
	"./account.svg": "ef22",
	"./all.svg": "6d66",
	"./attachent.svg": "ffde",
	"./calculator.svg": "879a",
	"./close.svg": "7710",
	"./cloud.svg": "61e1",
	"./company.svg": "9ef7",
	"./dashboard.svg": "f782",
	"./editor.svg": "8dba",
	"./example.svg": "30c3",
	"./exchange.svg": "7367",
	"./eye-open.svg": "d7ec",
	"./eye.svg": "4df5",
	"./form.svg": "eb1b",
	"./gateway.svg": "dfc8",
	"./ipWhite.svg": "e169",
	"./job.svg": "52d5",
	"./link.svg": "18f0",
	"./message center.svg": "1d67",
	"./nested.svg": "dcf8",
	"./password.svg": "2a3d",
	"./permission.svg": "3979",
	"./product.svg": "8d30",
	"./remind.svg": "18ef",
	"./rmb.svg": "0df8",
	"./role.svg": "520c",
	"./signboard.svg": "9d4b",
	"./similar-product.svg": "a3f0",
	"./sound-filling.svg": "89e6",
	"./suggest.svg": "036e",
	"./supplier-features.svg": "95f6",
	"./switch.svg": "2384",
	"./sys.svg": "7213",
	"./table.svg": "47f1",
	"./tool-hardware.svg": "d8bf",
	"./training.svg": "a9c4",
	"./tree.svg": "93cd",
	"./user center.svg": "7478",
	"./user.svg": "b3b5",
	"./video.svg": "8f2b",
	"./viewgallery.svg": "fcfc",
	"./voice.svg": "3f0e",
	"./wallet.svg": "402b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";